import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, PickaxeIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} tomos premium`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} bonos estratégicos`
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="field-grid-light relative isolate overflow-hidden bg-cream" data-id="element-110" data-mp="sai535t46z7u">
      <div className="furrow-bar h-2 w-full" aria-hidden="true" data-id="element-111" data-mp="ncgiiawhchrm" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-112" data-mp="neavn31if5l5">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-md bg-forest-900 px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-gold-300" data-id="element-113" data-mp="3d2tln1u126au">
          <PickaxeIcon className="h-4 w-4" aria-hidden="true" data-id="element-114" data-mp="39albailw2w59" /> Megapack Minería Listo
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-forest-950 sm:text-5xl lg:text-6xl" data-id="element-115" data-mp="3e961dp7ffzfz">
          Todo tu año de Minería
          <br data-id="element-116" data-mp="2qhqtzi0smrxv" />
          <span className="text-earth-700 underline decoration-gold-500 decoration-[6px] underline-offset-[10px]" data-id="element-117" data-mp="2qi0o9hsvfl9d">
            resuelto en una tarde.
          </span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-10 max-w-3xl rounded-2xl border border-earth-200 bg-white p-3 shadow-xl shadow-earth-900/10 sm:p-5" data-id="element-118" data-mp="2hl9qn0yo7yco">
          <img src={productImage} alt="Megapack Minería Listo: nueve tomos y cinco bonos sobre fundamentos, geología, exploración, explotación, procesamiento, seguridad, ambiente, sociedad y enseñanza de la minería" className="mx-auto w-full rounded-xl" data-id="element-119" data-mp="iboyiltrcouw" />
        </motion.div>

        <div className="mt-9" data-id="element-120" data-mp="162ufx5fcjp7b">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-121" data-mp="15zq2rijwlj4i">
            Quiero mi Megapack ahora
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-forest-900" data-id="element-122" data-mp="x1w80c1sexjg">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-md border border-earth-200 bg-white px-3 py-2" data-id="element-123" data-mp="3lqm1dvdxqztc">
              <Icon className="h-3.5 w-3.5 text-gold-600" aria-hidden="true" data-id="element-124" data-mp="1xavz0ob4wg9d" />
              {label}
            </li>)}
        </ul>
      </div>
    </section>;
}